// extracted by mini-css-extract-plugin
export default {"textH4":"TextH4_textH4__GIXuU"};